/**
 * Triggering animations using
 */

// Ratio of viewport that elements should be fully faded in by
const fadeInRatio = 0.4;

intersectionCallback = (entries) => {
    entries.forEach((entry) => {

        // Update opacity for those using scroll fading
        if (entry.target.classList.contains("scroll-fade-in") && entry.target.style.opacity < 1) {

            let fadeInPoint = window.innerHeight * fadeInRatio;

            /**
             * If necessary, factor in how much of the element needs to intersect the
             * viewport to reach the fade in point.
             */ 
            entry.target.style.opacity = entry.target.offsetHeight > fadeInPoint
                    ? entry.intersectionRatio * (entry.target.offsetHeight / fadeInPoint)
                    : entry.intersectionRatio
            ;
        }

        if ((entry.target.classList.contains('draw-from-right') || entry.target.classList.contains('draw-from-left') || entry.target.classList.contains('draw-from-top')) && entry.isIntersecting && entry.intersectionRatio > 0.6) {
        	entry.target.classList.add('in-view');
        }
        else if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
        }
    });
};

// Create an intersection observer that checks in 10% intervals
let options = {
    root: null,
    rootMargin: "0px",
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
};
const observer = new IntersectionObserver(intersectionCallback, options);


// Find the elements we need to animate
const animElements = document.querySelectorAll('.animate');
animElements.forEach((el) => observer.observe(el));
